<div>
  <app-page>
    <app-page-title title="Administration">
      <dx-button
        *ngIf="showDeleteButton"
        [disabled]="!selectedRows.length"
        class="cta-btn"
        type="default"
        [text]="'COMMON.DELETE' | translate"
        (click)="deleteSelected()"
      ></dx-button>
      @if (isTrainingGroupsTab) {
        <dx-button
          class="cta-btn"
          type="normal"
          icon="add"
          [text]="'ADMINISTRATION.OVERVIEW.ADD-GROUP' | translate"
          (click)="trainingGroupNavigateHandler()"
        ></dx-button>
      } @else if (isTrainingCategoriesTab) {
        <dx-button
          class="cta-btn"
          type="normal"
          icon="add"
          [text]="'ADMINISTRATION.OVERVIEW.ADD-TRAINING-CATEGORY' | translate"
          (click)="trainingCategoryNavigateHandler()"
        ></dx-button>
      } @else if (isTextTemplatesTab) {
        <dx-button
          class="cta-btn"
          type="normal"
          icon="add"
          [text]="'ADMINISTRATION.OVERVIEW.ADD-TEXT-TEMPLATE' | translate"
          (click)="textTemplateNavigateHandler()"
        ></dx-button>
      } @else if (isMarketingChannelsTab) {
        <dx-button
          class="cta-btn"
          type="normal"
          icon="add"
          [text]="'CHANNELS.ADD-CHANNEL.TITLE' | translate"
          (click)="onAddChannelClick()"
        ></dx-button>
      } @else if (isEventOverviewPageTab) {
        <div class="event-publishing-settings-actions">
          @if(!eventPublishingSettings) {
            <dx-button
              [text]="'COMMON.CREATE' | translate"
              type="normal"
              (click)="eventPublishingSettingsForm.submitForm()"
            ></dx-button>
          } @else {
            <dx-button
              icon="copy"
              [text]="'EVENT-PUBLISHING-SETTINGS.COPY-OVERVIEW-PAGE-LINK' | translate"
              type="normal"
              (click)="eventPublishingSettingsForm.copyEventOverviewLink()"
            ></dx-button>
            <dx-drop-down-button
              [splitButton]="true"
              [text]="'COMMON.SAVE' | translate"
              stylingMode="contained"
              type="normal"
              [dropDownOptions]="{ width: 230 }"
              (onButtonClick)="eventPublishingSettingsForm.submitForm()"
            >
              <dxi-item (click)="eventPublishingSettingsForm.openDeletePublishingSettingsConfirmationModal()">{{
                "EVENT-PUBLISHING-SETTINGS.DELETE-EVENT-OVERVIEW-SETTINGS" | translate
              }}</dxi-item>
            </dx-drop-down-button>
          }

        </div>
      }
    </app-page-title>
    <dx-tabs
      width="100%"
      [selectedIndex]="(selectedTab$ | async) || AdministrationTabs.TrainingGroups"
      [showNavButtons]="false"
      [dataSource]="tabs"
      (onItemClick)="onTabChange($event)"
    ></dx-tabs>
    <div class="table-wrapper">
      @if (selectedTab?.description) {
        <div
          class="tab-description"
          [innerHTML]="selectedTab.description">
        </div>
      }

      @if (isTrainingGroupsTab) {
        <app-table
          [data]="(trainingGroups$ | async) || []"
          [columns]="trainingGroupColumns"
          [showSearch]="true"
          [searchLabel]="'COMMON.SEARCH' | translate"
          [searchPlacehoder]="'COMMON.SEARCH' | translate"
          (selectHandler)="onRowSelected($event)"
          (onRowClick)="trainingGroupNavigateHandler($event)"
          [stateKey]="trainingGroupsStateKey"
          [showFilterPanel]="true"
        ></app-table>
      } @else if (isTrainingCategoriesTab) {
        <app-table
          [data]="(trainingCategories$ | async) || []"
          [columns]="trainingCategoryColumns"
          [showSelection]="true"
          [showSearch]="true"
          [searchLabel]="'COMMON.SEARCH' | translate"
          [searchPlacehoder]="'COMMON.SEARCH' | translate"
          (selectHandler)="onRowSelected($event)"
          (onRowClick)="trainingCategoryNavigateHandler($event)"
          [stateKey]="trainingCategoriesStateKey"
          [templates]="{
            trainingCategoryNameTemplate: trainingCategoryNameTemplate
          }"
          [showFilterPanel]="true"
        ></app-table>
        <ng-template #trainingCategoryNameTemplate let-data>
          <ng-container *ngIf="data.data as category">
            <div class="training-category-name-container">
              <span>{{ category.name }}</span>
              <span
                class="category-origin-badge"
                [ngClass]="{
                  'category-origin-badge-standard': category.standardTrainingCategoryId,
                  'category-origin-badge-custom': !category.standardTrainingCategoryId
                }">

                <ng-container *ngIf="category.standardTrainingCategoryId">
                  <i
                    class="dx-icon dx-svg-icon"
                    [innerHTML]="getLockIcon()">
                  </i>
                </ng-container>

                {{
                  (
                    category.standardTrainingCategoryId
                      ? 'ADMINISTRATION.TRAINING-CATEGORY.TRAINING-CATEGORY-TYPE.STANDARD'
                      : 'ADMINISTRATION.TRAINING-CATEGORY.TRAINING-CATEGORY-TYPE.CUSTOM'
                  ) | translate
                }}
              </span>
            </div>
          </ng-container>
        </ng-template>
      } @else if (isTextTemplatesTab) {
        <app-table
          [data]="(textTemplates$ | async) || []"
          [columns]="textTemplateColumns"
          [showSelection]="true"
          [showSearch]="true"
          [searchLabel]="'COMMON.SEARCH' | translate"
          [searchPlacehoder]="'COMMON.SEARCH' | translate"
          (selectHandler)="onRowSelected($event)"
          (onRowClick)="textTemplateNavigateHandler($event)"
          [stateKey]="textTemplatesStateKey"
          [showFilterPanel]="true"
        ></app-table>
      } @else if (isMarketingChannelsTab) {
        <app-marketing-channels
          #marketingChannels
        ></app-marketing-channels>
      } @else if (isEventOverviewPageTab) {
        <app-panel
          class="settings-panel"
          [title]="'ADMINISTRATION.OVERVIEW.EVENT-OVERVIEW-PAGE-TAB' | translate"
        >
          <app-tenant-event-publishing-settings-form
            #eventPublishingSettingsForm
            [(eventPublishingSettings)]="eventPublishingSettings"
            [isTenantPublishedToSubscribers]="isPublishedToSubscribers"
          ></app-tenant-event-publishing-settings-form>
        </app-panel>
      }
    </div>
  </app-page>
</div>
